<template>
  <div class="Content" :style="inputStyle.content">
    <div class="logo" v-if="content.logo" :style="inputStyle.logoDiv">
      <logo :logo="content.logo" :inputStyle="inputStyle.logo"></logo>
    </div>
    <my_title :content="content.title" :style="inputStyle.title"></my_title>
    <div class="text" :style="inputStyle.text">
      <div v-if="Array.isArray(content.text)">
        <div v-for="txt in content.text" class="paragraph">{{txt}}</div>
      </div>
      <div v-else>
        {{content.text}}
      </div>
    </div>
    <div class="link" v-if="link" @click="nav">
      >>>进入官网
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import MyTitle from '@/components/Title.vue';

 export default {
   name: 'MyContent',
   props: ['content', 'inputStyle', 'link'],
   methods: {
     nav() {
       window.open(this.link, '_blank');
     }
   },
   components: {
     logo: Logo,
     my_title: MyTitle
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Content{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
   color: white;
   position: relative;
 }
 .logo{
   display: flex;
   justify-content: center;
   align-items: center;
 }
 .paragraph{
   text-align: start;
   margin-bottom: 1.5em;
   line-height: 1.2vw;
 }
 .link{
   position: absolute;
   align-self: flex-end;
   bottom: 2vw;
   cursor: pointer;
 }


 @media (min-width: 320px) and (max-width: 480px) {
   .Content{
     overflow-y: auto;
   }
   .paragraph{
     line-height: 2.3vw;
     font-size: 6px;
   }
   .link{
     font-size: 10px;
   }
 }

</style>
